import React, { useState, useRef } from 'react';
import {
  Objetivos,
  Contacto2
} from 'components/articles';
import Button from 'components/ui/button';
import './index.css';
import image from 'assets/images/main-funcionario.jpg';

export default function Funcionario() {
  const inputRef = useRef(null);
  const [article, setArticle] = useState(null);
  const variant = "funcionario";

  const selectArticle = item => {
    setArticle(item);
    const scrollto = inputRef.current.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top: scrollto, behavior: 'smooth' });
  }

  return (
    <div className={`wrapper ${variant}`}>
      <div className="content-cols">
        <figure>
          <img src={image} alt="¿Sos funcionario/a municipal?" />
          <figcaption>¿Sos funcionario/a<br />municipal?</figcaption>
        </figure>
        <section>
          <div className='copete'>
            <h4>En un mundo donde la economía y las finanzas juegan un papel crucial, es esencial que los municipios tengan el conocimiento y las habilidades para manejar eficientemente los recursos públicos.</h4>
            <p>En coordinación con la Escuela de Economía y Gestión para el Desarrollo Local de la Provincia de Buenos Aires y el Grupo Provincia fue diseñado un <strong>curso autogestionado para funcionarias y funcionarios municipales de las carteras de Hacienda, Presupuesto, Contabilidad y Tesorería</strong>.</p>
          </div>
          <div className="segment-nav">
          <Button
            article='objetivos'
            active={article === 'objetivos'}
            onclick={() => selectArticle('objetivos')}
          />
          <Button
            article='contacto'
            active={article === 'contacto'}
            onclick={() => selectArticle('contacto')}
          />
          </div>
        </section>
      </div>
      <div ref={inputRef}>
        {article &&
          <article>
            {article === 'objetivos' && <Objetivos />}
            {article === 'contacto' && <Contacto2 />}
          </article>
        }
      </div>
    </div>
  );
}